import { IPropAuthLayout } from "types/auth/authLayout";
import * as React from "react";
import { SupportAuth } from "assets/images";
import { useNavigate } from "react-router-dom";
const AuthLayout: React.FC<IPropAuthLayout> = ({ children }) => {
  const divScroll = React.useRef<any>(null);

  const navigate = useNavigate();

  const openSupportCallHandler = () => {
    navigate("/contact-us");
  };

  return (
    <div ref={divScroll} className="authLayoutScroll scrollbar-div">
      <div className="authLayoutContainer">
        {children}
        <img
          className="icon-supportCallAuth"
          src={SupportAuth}
          alt="supportCall"
          onClick={openSupportCallHandler}
        />
      </div>
    </div>
  );
};

export default AuthLayout;
